var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip0_5796_3311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 8.24973C22.5318 8.75634 21.7366 9.14381 20.895 9.39723C20.4433 8.87786 19.843 8.50975 19.1753 8.34267C18.5076 8.1756 17.8046 8.21763 17.1616 8.46307C16.5185 8.70851 15.9663 9.14553 15.5797 9.71502C15.1931 10.2845 14.9908 10.959 15 11.6472V12.3972C13.682 12.4314 12.376 12.1391 11.1983 11.5463C10.0206 10.9535 9.00774 10.0787 8.25 8.99973C8.25 8.99973 5.25 15.7497 12 18.7497C10.4554 19.7982 8.61537 20.3239 6.75 20.2497C13.5 23.9997 21.75 20.2497 21.75 11.6247C21.7493 11.4158 21.7292 11.2074 21.69 11.0022C22.4555 10.2473 22.9956 9.29426 23.25 8.24973V8.24973Z",
    stroke: "#fff",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5796_3311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.93bdfafced42ab582e7ee57365217a4e.svg";
export { ForwardRef as ReactComponent };